import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete-help-contact-modal',
  templateUrl: './confirm-delete-help-contact-modal.component.html'
})
export class ConfirmDeleteHelpContactModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
